import TimeOffCard from './TimeOffCard.component';

export default TimeOffCard;
